import { PimProductT } from '@lambda/apis/src/dynamoDb/types';
import { extractTags } from '@lambda/reebelo/src/tagHelpers';
import { invert } from 'lodash-es';
import {
  REEBELO_DOMAINS,
  REEBELO_CURRENCY,
  REEBELO_STORE_TO_LANGUAGE,
} from '@lambda/reebelo';
import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import settings from '@/settings';
import i18n from '@/settings/i18n';
import { replacePlusSymbol } from '../../../pages/products/[handle]';

const t = i18n.init();

export default (props: {
  offer: SearchOffers;
  product: PimProductT;
  title: string;
  handle: string;
  description?: string;
}) => {
  const { offer, product, title, description, handle } = props;
  const { color } = extractTags(offer.tags);
  const variantPrice = offer.price;
  const colorCode = invert(props.product.colors)[color as any];
  const image = product.images[colorCode]?.[0];
  const language = REEBELO_STORE_TO_LANGUAGE[settings.store];

  let propDescription = '';

  if (description) {
    propDescription = description;
  } else {
    propDescription = t`Find great deals for refurbished ${{
      name: product.locale?.[language]?.name ?? product.name,
    }} devices at Reebelo. All devices are 100% functional and come with ${{
      warranty_month: settings.warranty_month,
    }} months warranty. Good for your wallet and the environment!`;
  }

  const domain = REEBELO_DOMAINS[settings.store];

  return (
    <>
      <meta name="description" content={replacePlusSymbol(propDescription)} />
      <meta property="product:price:amount" content={variantPrice.toString()} />
      <meta
        property="product:price:currency"
        content={REEBELO_CURRENCY[settings.store]}
      />

      <meta property="og:type" content="product" />
      <meta property="og:title" content={title} />
      {image && (
        <>
          <meta property="og:image" content={image} />
          <meta property="og:image:secure_url" content={image} />
        </>
      )}
      <meta property="og:description" content={propDescription} />
      {handle && (
        <meta property="og:url" content={`https://${domain}/${handle}`} />
      )}
      <meta property="og:site_name" content={`Reebelo ${settings.country}`} />
      {/* TWITTER */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={product.name} />
      <meta name="twitter:description" content={propDescription} />
      <meta name="twitter:image" content={image} />

      {/* OTHERS KIV */}
      {/*
      <meta
        name="shopify-checkout-api-token"
        content="635541d9cce1ce2cf373894555ad5d9b"
      />
      <meta
        id="in-context-paypal-metadata"
        data-shop-id="42327507093"
        data-venmo-supported="false"
        data-environment="production"
        data-locale="en_US"
        data-paypal-v4="true"
        data-currency="AUD"
      /> */}
    </>
  );
};
